import PropTypes from 'prop-types'

/** Full-screen loading wash for vault writes (mock's busy overlay):
 * "Saving your story to your Everplan…", "Deleting your story…". */
const BusyOverlay = ({message}) => (
  <div aria-live='polite' className='ls-busy-overlay'>
    <span aria-hidden='true' className='ls-spin' />
    <div className='ls-busy-message'>{message}</div>
  </div>
)

BusyOverlay.propTypes = {
  message: PropTypes.string
}

export default BusyOverlay
